//admin src/containers/ChatPage/formatChatPreview.js (или где у тебя лежит)
export function formatChatPreview(lastMessage, meId) {
    if (!lastMessage) return '';
    const sender = String(lastMessage.senderId || lastMessage.sender || '');
    const you = sender === String(meId) ? 'Вы: ' : '';

    if (lastMessage.type === 'call' || lastMessage.call) {
        const c = lastMessage.call || {};
        const kind = c.video ? 'видеозвонок' : 'звонок';
        const dir = you ? 'исходящий' : 'входящий';
        return `${you}${dir} ${kind}${c.status ? ` • ${c.status}` : ''}`;
    }
    if (lastMessage.fileName || lastMessage.fileUrl) {
        return `${you}📎 ${lastMessage.fileName || 'Вложение'}`;
    }
    if (lastMessage.text?.startsWith('↩️ ')) {
        const nl = lastMessage.text.indexOf('\n');
        const body = nl > -1 ? lastMessage.text.slice(nl + 1) : '';
        return `${you}${body || 'Ответ на сообщение'}`;
    }
    return `${you}${lastMessage.text || ''}`;
}
